import DatabricksDashboardEmbedPage from './dashboard-databricks-embed.vue';
import { dashboards as dashboardsPageIndex } from '@enums/page-index';
import {
  enableDatabricksDashboards,
  enableDashboardPricingBasketAnalysis,
} from '@enums/feature-flags';

const routes = [
  {
    path: '/dashboards',
    name: 'dashboards',
    id: 'dashboards',
    component: DatabricksDashboardEmbedPage,
    beforeEnter: (to, from, next) => {
      // The root /dashboards should never be reached through the UX, unless users manually manipulate the URL
      // If that happens, we wouldnt know which dashboard to show,
      // for now redirect to home, although we could also redirect to the first enabled dashboard.
      if (to.path === '/dashboards') {
        return next({ name: 'home' });
      }
      // Otherwise we are loading one of the children route for specific dashboards
      return next();
    },
    linkText: 'linkText.dashboards',
    index: dashboardsPageIndex,
    meta: {
      featureFlag: enableDatabricksDashboards,
      requiresPermission: 'can-access-dashboards',
    },
    children: [
      // NOTE: The dashboardKey within each rotute's meta should match exactly the same key values
      //       found in the the "dashboards" inside configuration/fabric-data.yaml
      {
        path: 'pricing-basket-analysis',
        name: 'pricing-basket-analysis',
        id: 'pricing-basket-analysis',
        component: DatabricksDashboardEmbedPage,
        linkText: 'linkText.dashboardPricingBasketAnalysis',
        meta: {
          selectedWorkpackageRequired: false,
          title: 'tabText.dashboardPricingBasketAnalysis',
          featureFlag: enableDashboardPricingBasketAnalysis,
          dashboardKey: 'pricing_basket_analysis',
          // NOTE: We could define granular permission that allow certain roles to view some dashboards but not others.
          //       This would also need to be enforeced within the backend controller, based on the "dashboardKey" received.
          // requiresPermission: 'can-access-dashboards-pricing-basket-analysis',
        },
      },
    ],
  },
];

export default routes;
